import { Page } from '@/core/architecture'

import { ResaleRaffleDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleRaffleDetail Page
 * Implemented as a practical sample.
 */
export const ResaleRaffleDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleRaffleDetailTemplate state={state} {...actions} />
}
